import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Icon from "../../../Icon";
import useTranslations from "../../../../../core/i18n/useTranslations";
import { SubNavLink } from "../../../../../core/interfaces/SubNav";
import { SideBarLink } from "../SideBarLink";

import styles from "./CollapsibleSubItem.module.css";

export const CollapsibleSubItem = ({
  title,
  subItems,
}: {
  title: string;
  subItems?: SubNavLink[];
}) => {
  const t = useTranslations();
  const [isShown, setIsShown] = useState<boolean>(false);
  const [isSubLinkActive, setIsSubLinkActive] = useState<boolean>(false);
  const [contentHeight, setContentHeight] = useState<number>(0);

  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isSubLinkActive) {
      setIsShown(true);
    }
  }, [isSubLinkActive]);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.clientHeight);
    }
  }, [isShown]);

  return (
    <>
      <button
        type="button"
        className={classNames(styles.collapsibleItem, {
          [styles.collapsibleTitleWrapperOpen]: isSubLinkActive,
        })}
        onClick={() => {
          setIsShown(!isShown);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" || e.code === "Space") {
            e.preventDefault();
            setIsShown(!isShown);
          }
        }}
      >
        <div className={styles.collapsibleTitleWrapper}>
          <span>{title}</span>
          <Icon
            className={styles.chevronIcon}
            color={isSubLinkActive ? "Primary-700" : undefined}
            name={isShown ? "chevron-up" : "chevron-down"}
            size={18}
          />
        </div>
      </button>
      <div
        className={styles.collapseContent}
        // this need for correct work of transition style
        style={{ height: isShown ? contentHeight : 0 }}
      >
        {isShown && (
          <div ref={contentRef}>
            {subItems?.map((el) => (
              <SideBarLink
                withSpace
                // Key that contained in subpage path
                watchKey={el.watchKey}
                key={el.key}
                text={t(`${el.key}`)}
                to={el.to}
                setIsSubLinkActive={setIsSubLinkActive}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};
